import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TimeWindow from "@/models/TimeWindow.js";
import TimeWindowCron from "@/components/time-window/create/TimeWindowCron.vue";
import AssignedVisitPointList from "@/components/visit-point/list/AssignedVisitPointList.vue";
import FloatingButtons from "@/views/FloatingButtons.vue";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export const TimeWindowMixin = {
	name: "TimeWindowCreate",
	mixins: [generalPurposeMixin],
	components: {
		vSelect,
		flatPickr,
		TimeWindowCron,
		AssignedVisitPointList,
		FloatingButtons,
	},
	data() {
		return {
			timewindow: new TimeWindow({}),
			typeTimeWindow: {},
			cronExpresion: "",
			activeNavItem: 0,
			maximize: false,
			isSoftTimeWindow: false,
			compareDuration: false,
			soft_time_window: null,
			durationProps: "12:00:00",
			showDateTime: new Date(),
			typeTimeWindowList: [
				{text: this.$t("TimeWindow.Daily"), value: "daily"},
				{text: this.$t("TimeWindow.Monthly"), value: "monthly"},
				{text: this.$t("TimeWindow.Weekly"), value: "weekly"},
			],
		};
	},
	watch: {
		durationTimeWindow(val) {
			this.durationProps = val;
		},
	},
	computed: {
		navbarTitle() {
			if (this.activeNavItem === 0) return this.$t("Crud.Create") + " " + this.$t("TimeWindow.Schedule");
			else return this.$t("VisitPoints.Add") + " " + this.$t("Routing.Title.VisitPoints");
		},
		validateForm() {
			return !this.errors.any();
		},
		cronExpression() {
			return this.$store.state.moduleTimeWindow.cronExpression;
		},
		durationTimeWindow() {
			return `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getCronExpresion(val) {
			this.cronExpresion = val;
		},
		maximizeCalendar(val) {
			this.maximize = val;
		},
		isSoftTimeWindowEmit(val) {
			this.isSoftTimeWindow = val;
		},
		compareDurationEmit(val) {
			this.compareDuration = val;
		},
		softWindowEmit(val) {
			this.soft_time_window = val;
		},
		validateInputNumberMinutes(event) {
			if (this.minutes.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(event) {
			if (this.seconds.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		save() {
			let params = {};
			delete this.timewindow.id;
			this.timewindow["visit_point_id"] = this.$store.state.moduleVisitPoint.assignedVisitPoints.map(
				({id}) => id
			);
			this.timewindow["duration"] = `${this.hours < 10 ? "0" + this.hours : this.hours}:${
				this.minutes < 10 ? "0" + this.minutes : this.minutes
			}:${this.seconds < 10 ? "0" + this.seconds : this.seconds}`;
			this.timewindow["cron"] = this.$store.state.moduleTimeWindow.cronExpression;
			if (this.isSoftTimeWindow) {
				this.timewindow["soft_time_window"] = {
					before_soft_duration: this.soft_time_window.before_soft_duration,
					after_soft_duration: this.soft_time_window.after_soft_duration,
					before_soft_cost: parseFloat(this.soft_time_window.before_soft_cost),
					after_soft_cost: parseFloat(this.soft_time_window.after_soft_cost),
				};
			}
			params = {...this.timewindow};
			this.$store
				.dispatch("moduleTimeWindow/save", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TimeWindow.Messages.TitleConfirmCreate"),
						text: this.$t("TimeWindow.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "app-time-window-list"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result && this.isSoftTimeWindow && !this.compareDuration) {
					this.save();
				} else if (result) {
					this.save();
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		getShowDate(val) {
			this.showDateTime = val;
		},
	},
};
